import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-nosotros',
  templateUrl: './hero-nosotros.component.html',
  styleUrls: ['./hero-nosotros.component.scss']
})
export class HeroNosotrosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
